import { AxiosInstance } from 'axios';
import {
  ISigninBody,
  TSigninResponse,
  IVerifyDeviceBody,
  TVerifyDeviceResponse,
  IResendVerifyDeviceBody,
  TResendVerifyDeviceResponse,
  IAvailabilityQuery,
  TAvailabilityResponse,
  IInitiateResetPasswordBody,
  TInitiateResetPasswordResponse,
  ICheckResetPasswordBody,
  TCheckResetPasswordResponse,
  ICompleteResetPasswordBody,
  TCompleteResetPasswordResponse,
} from 'types/memberCenter';

export const memberCenterApi = (axios: AxiosInstance, apiDomain: string) => ({
  /**
   * 登入
   */
  signin(payload: ISigninBody): Promise<TSigninResponse> {
    return axios.post(`${apiDomain}/auth/signin`, payload);
  },

  /**
   * 驗證裝置驗證碼（信箱或手機）
   */
  verifyDevice(payload: IVerifyDeviceBody): Promise<TVerifyDeviceResponse> {
    return axios.post(`${apiDomain}/auth/verify/device`, payload);
  },

  /**
   * 重發裝置驗證碼（信箱或手機）
   */
  resendVerifyDevice(
    payload: IResendVerifyDeviceBody,
  ): Promise<TResendVerifyDeviceResponse> {
    return axios.post(`${apiDomain}/auth/verify/device/resend`, payload);
  },

  /**
   * 確認 帳號 | 信箱 | 手機 是否可用
   */
  checkAvailability(query: IAvailabilityQuery): Promise<TAvailabilityResponse> {
    return axios.get(`${apiDomain}/auth/availability`, { params: query });
  },

  /**
   * 重設密碼-寄送驗證碼
   */
  initiateResetPassword(
    payload: IInitiateResetPasswordBody,
  ): Promise<TInitiateResetPasswordResponse> {
    return axios.post(`${apiDomain}/auth/reset-password/initiate`, payload);
  },

  /**
   * 重設密碼-驗證驗證碼
   */
  checkResetPassword(
    payload: ICheckResetPasswordBody,
  ): Promise<TCheckResetPasswordResponse> {
    return axios.post(`${apiDomain}/auth/reset-password/check`, payload);
  },

  /**
   * 送出新密碼
   */
  completeResetPassword(
    payload: ICompleteResetPasswordBody,
  ): Promise<TCompleteResetPasswordResponse> {
    return axios.post(`${apiDomain}/auth/reset-password/complete`, payload);
  },
});
